/*
    Výběr veškerých kategorií
*/
import React,{ Component } from 'react';
import {Query,Mutation} from 'react-apollo';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import NoItems from '../../../GlobalComponents/NoItems';
import {GET_MEMBERSHIPS,DELETE_MEMBERSHIPS} from '../Queries/index.js';
import AddEditMembership from './AddEditMembership';
import Helper from '../../../Library/helper';
import edit from '../../../Public/Images/edit.svg';
import Notification from '../../../Library/notification';
import MembershipLib from '../Library/membership';
import { withApollo } from 'react-apollo';

const INITIAL_STATE = {
    showDeleteCategoryNotifi : false,
    showDoNotDelete:false,
    showAddCategory:false,
    selectedMembershipID:0,
    membershipDurationID:0,
    deleteCat:null,
    selectedItems:[],
    showAddCategory : false,
    showDeleteNotifi:false,
    listVariables:{
        lang:"cz"
    }

}

class AllMemberships extends Component{


    constructor(props){
        super(props);
        this.state = INITIAL_STATE;
    }


    delCategory = (action) => {
        if(action){
            let membershipDurationIDs = this.state.selectedItems.join(",");
            this.state.deleteMemberships({
                variables:{
                    membershipDurationIDs
                }
            });
            
            this.setState(INITIAL_STATE);
        }else{
            this.setState({
                showDeleteNotifi:false
            });
        }
    }

    showDoNotDel = (action) => {
        this.setState({
            showDoNotDelete:action
        });
    }

    openCloseModal = (type,membershipDurationID) => {

        this.setState({
            showAddCategory:type,
            selectedMembershipID:membershipDurationID
        })
    }
    
    /**
     * smazání kategorie
     * @param {*} deleteMemberships funkce, která posílá data na server
     * @param {*} membershipDurationID ID kategorie
     */
    
    checkItemToDelete = (e,deleteMemberships,membershipDurationID) => {

        var checked = e.target.checked;
        var arr = [...this.state.selectedItems];

        if(!checked){
            for(let i in this.state.selectedItems){
                if(this.state.selectedItems[i] == membershipDurationID){
                    arr.splice(i,1);
                }
            }
        }else{
            arr = [membershipDurationID,...arr];
        }
        
        this.setState({
            deleteMemberships,
            selectedItems:arr
        });
  
    }
    
    openCloseAddCategoryModal = (type) => {
        this.setState({
            showAddCategory:type,
        })
    }
    
    showDelNotifi = () => {

        if(this.state.selectedItems.length > 0){
            this.setState({
                showDeleteNotifi:true
            });
        }else{
            let notify = new Notification();
            notify.setNotification(null,'Nevybrali jste žádnou položku.',false,true,this.props.client);
        }
    }
    onDragEnd = (result,updateCategoryPriority) => {

        const IDs = result.draggableId.split("-");

        updateCategoryPriority({
            variables:{
                membershipDurationID: IDs[0],
                fromIndex:result.source.index,
                toIndex:  result.destination.index
            }
        });

    }

    render(){
        
        const {selectedItems,listVariables} = this.state;

        return(
            <div id="settings" className="whole-container" >
            	
                <div className="row" >
                    <div className="col-sm one">
                        <div className="card main">
                            
                            <div className="card-header d-flex align-items-center">
                                Členství / produkty
                                <button className="btn btn-primary btn-thiner ml-auto" onClick={() => this.openCloseModal(true)}>Přidat</button>
                                <button className="btn btn-danger btn-thiner ml-2" onClick={() => this.showDelNotifi()}>Smazat označené</button>
                            </div>
                            <div className="card-body">
                                <Query query={GET_MEMBERSHIPS} errorPolicy="all" variables={listVariables}>
                                    {
                                        ({data,loading,error,refetch }) => {
                                            if(error){
                                                const helper = new Helper(); 
                                                return (<Error text={helper.getApolloErrorText(error)} />);
                                            }
                                            if(loading) return (<Loading />);
                                            
                                            return(
                                                <div>
                                                    <div className="data-list">
                                                        
                                                            <div className="data-list-item header">
                                                                <div className="data-list-item-content">
                                                                    <div>Název členství / produktu</div>
                                                                    <div className="text-center">Aktivní</div>
                                                                    <div className="text-center">Délka</div>
                                                                    <div className="text-center">Počet automatických plateb</div>
                                                                    <div className="text-center">Cena</div>
                                                                    <div className="text-center">Popis</div>
                                                                    <div className="text-right">Možnosti</div>
                                                                </div>
                                                            </div>

                                                            <Mutation
                                                                mutation = {DELETE_MEMBERSHIPS}
                                                                update = {async (cache, response) => {
                                                                    
                                                                    let membership = new MembershipLib(this);
                                                                    membership.updateAfterDelete(cache, response);

                                                                    let notify = new Notification();
                                                                    notify.setNotification(cache,'Úspěšně smazáno',true,false);
                                                
                                                                }}
                                                                onError = {(error) => {
                                                                    const helper = new Helper(); 
                                                                    let notify = new Notification();
                                                                    notify.setNotification(null,helper.getApolloErrorText(error),false,true,this.props.client);
                                                                }}
                                                            >
                                                                {
                                                                    (deleteMemberships,response) => {
                                                                
                                                                        return(
                                                                            
                                                                            <div>
                                                                                {data.allMemberships && data.allMemberships.map((item,index) => {
                                                                                    
                                                                                    if(item.membershipDurationID){
                                                                                        
                                                                                        var checked = false;
                                                                                        for(let i in selectedItems){
                                                                                            if(selectedItems[i] == item.membershipDurationID)checked = true;
                                                                                        }

                                                                                        return (
                                                                                            
                                                                                            <div key={index} className="data-list-item">
                                                                                                <div className="data-list-item-content categories">
                                                                                                    <div className="cross" style={{paddingLeft:10}}>
                                                                                                        {item.name}
                                                                                                    </div>
                                                                                                    <div className="text-center">{(item.active == 1 ? "ANO" : "NE" )}</div>
                                                                                                    <div className="text-center">{item.length} měsíců</div>
                                                                                                    <div className="text-center">{item.autoPaymentsNumber}</div>
                                                                                                    <div className="text-center">{item.value} Kč</div>
                                                                                                    <div className="text-center">{item.description}</div>
                                                                                                    <div className="text-right">
                                                                                                        <img onClick={() => this.openCloseModal(true,item.membershipDurationID)} className="edit-icon" src={edit} /> 
                                                                                                        <input className="delete-checked" type="checkbox" name="membershipsToDelete[]" checked={checked} onChange = {(e) => this.checkItemToDelete(e,deleteMemberships,item.membershipDurationID)} />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        )
                                                                                    }else{
                                                                                        return "";
                                                                                    }
                                                                                })}
                                                                            </div>
                                                                        )
                                                                    }
                                                                }
                                                            </Mutation>
                                                        
                                                    </div>
                                                    {data.allMemberships && data.allMemberships.length == 0 &&
                                                        <NoItems text={"Momentálně se zde nenachází žádné položky."} />
                                                    }
                                                    {this.state.showDeleteNotifi && <ModalNotification yesNo={true} text={'Opravdu chcete vymazat vybrané položky ?'} callback={this.delCategory} /> }
                                                    {this.state.showAddCategory &&
                                                        <AddEditMembership listVariables={listVariables} openCloseModal={this.openCloseModal} selectedMembershipID={this.state.selectedMembershipID} />
                                                    }
                                                </div>
                                            );
                                        }
                                    }
                                </Query>
                            </div>
                        </div>
                    </div>
                </div> 			
            </div>
        
        );

    }

}


export default withApollo(AllMemberships);